import DefaultSelect from "components/DefaultSelect";
import { validParams } from "query_parameters/valid_parameters";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGlobal } from "reactn";
import { useQueryString } from "hooks/general-hooks";
import { updateQueryParamsIfChanged } from "lib/general-helper";
import { useHistory, useLocation } from "react-router-dom";

const EncounterFilter = (props) => {
  const { t } = useTranslation();
  const { disabled } = props;

  const [windowBreakpoint] = useGlobal("responsive");
  const isMobile =
    windowBreakpoint === "MOBILE_SMALL" || windowBreakpoint === "MOBILE_MEDIUM" || windowBreakpoint === "MOBILE_LARGE";

  const queryParams = useQueryString();
  const history = useHistory();
  const location = useLocation();
  const selectedEncounter = queryParams["encounter"] ?? "all_bosses";

  const onEncounterFilterChange = (val) => {
    if (val === "all_bosses") {
      delete queryParams["encounter"];
      updateQueryParamsIfChanged(history, location, queryParams);
    } else {
      updateQueryParamsIfChanged(history, location, { ...queryParams, encounter: val });
    }
  };

  const options = JSON.parse(JSON.stringify([...validParams.builds.encounters.amirdrassil]));
  options[0].label = location.pathname.split("/").length === 3 ? "Full Roster" : "Armory Data";

  if (disabled) {
    return null;
  }

  const formatOptionLabel = ({ value, label, img }) => (
    <div className="encounter-option">
      <span>{t(label)}</span>
    </div>
  );

  return (
    <DefaultSelect
      title={t("Change Encounter")}
      group={"class"}
      isMobile={isMobile}
      className="filter-select filter-select_class"
      options={options}
      onChange={(selected) => {
        onEncounterFilterChange(selected.value);
      }}
      value={selectedEncounter}
      formatOptionLabel={formatOptionLabel}
      width={150}
      isSearchable={false}
    />
  );
};

export default EncounterFilter;
